<div class="d-flex flex-column align-items-center">
	<div class="text-center text-muted my-5">
		<img class="img-fluid icon" src="/assets/images/icon-notime.svg" alt="no time logs icon" />

		<ng-container *ngIf="message">
			{{ message }}
		</ng-container>

		<ng-container *ngIf="!message">
			<ng-content></ng-content>
		</ng-container>
	</div>
</div>
